'use es6';

import SignupUrlGenerator from 'signup-ui-core/SignupUrlGenerator';
import { SignupFlows } from 'signup-ui-core/constants/SignupFlows';
import AllowedHubs from 'signup-ui-core/constants/AllowedHubs';
import { MEETING_SIDEBAR, VIRAL_SOURCE_PORTAL_ID } from 'signup-ui-core/constants/AllowedCustomOpts';
import AllowedIntents from 'signup-ui-core/constants/AllowedIntents';
import AllowedUtms from 'signup-ui-core/constants/AllowedUtms';
import { getEnvPostfix } from 'MeetingsBase/utils/utils';
export default function getFreemiumViralLink(viralPage, portalId) {
  var embedded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var campaign = embedded ? 'hubspot-meetings-embedded-virality' : 'hubspot-meetings-virality';
  var salesUrl = new SignupUrlGenerator(SignupFlows.SALES).withHubs(AllowedHubs.HUBS_CAMPAIGN, campaign).withHubs(AllowedHubs.HUBS_CTA, viralPage).withUtm(AllowedUtms.UTM_MEDIUM, 'virality').withOption(MEETING_SIDEBAR).withIntent(AllowedIntents.MEETINGS).withParam(VIRAL_SOURCE_PORTAL_ID, portalId).getUrl();
  var envPostfix = getEnvPostfix();
  return "https://app.hubspot" + envPostfix + ".com" + salesUrl;
}